import { asciiTextValidation } from 'framework/form';

export const createClientPortalTaskValidation = {
  id: {
    type: 'string',
    required: false,
  },
  alias: {
    type: 'string',
    required: false,
  },
  type: {
    type: 'string',
    required: true,
  },
  title: {
    type: 'string',
    required: true,
    maxSize: 1000,
    ...asciiTextValidation,
  },
  assigneeExternalUserId: {
    type: 'string',
    required: true,
  },
  dueDate: {
    type: 'string',
    required: true,
  },
  description: {
    type: 'string',
    required: false,
  },
  attachmentIds: {
    type: 'array',
    required: false,
  },
  responseLink: {
    type: 'string',
    required: false,
    link: true,
  },
};

export const cancelTaskValidation = {
  reason: {
    type: 'string',
    required: true,
  },
};
